export const saveFilterInLocalStorage = (filters) => {
    localStorage.setItem('mobileCatalogFilters', JSON.stringify(filters));
}

export const isChangedFilters = (filters) => {
    const savedFilters = localStorage.getItem('mobileCatalogFilters');
    Object.keys(filters).forEach(x => {
        if (filters[x] === false) {
            filters[x] = "";
        }
    })
    return savedFilters === JSON.stringify(filters);
}